import { forwardRef } from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import { useUser } from 'hooks/useAuth';

export const ProfileAvatar = forwardRef((_, _ref) => {
  const { user } = useUser();

  return (
    <Box display="flex" padding={3} alignItems="center">
      <Avatar
        alt={user.name}
        sx={{
          height: 35,
          width: 35
        }}
      />
      <Box display="flex" flexDirection="column" width={1} ml={2}>
        <Typography variant="h6">
          {user.name}
        </Typography>
      </Box>
    </Box>
  )
});